import axios from '../utils/axios';

export const getRegisterCountries = async () => {
    const { data } = await axios.get('/user/countries');
    return data;
};
